{
  "FundingContractStatus": {
    "Draft": "Concept",
    "Canceled": "Geannuleerd",
    "SentManually": "Verstuurd",
    "SentDigital": "Verstuurd",
    "SignedByFunder": "Getekend",
    "Active": "Rentedragend",
    "Inactive": "Inactief",
    "Validated": "Gecontroleerd"
  },
  "FundingContractVariant": {
    "Protected": "Beschermd (A)",
    "Plus": "Plus (B)"
  },
  "LegalStructure": {
    "SoleProprietor": "Eenmanszaak",
    "GeneralOrCommercialPartnership": "Vennootschap onder firma (vof)",
    "LimitedPartnership": "Commanditaire vennootschap (cv)",
    "ProfessionalOrPublicPartnership": "Maatschap",
    "PrivateLimitedCompany": "Besloten vennootschap (bv)",
    "Association": "Vereniging",
    "Foundation": "Stichting",
    "PublicLimitedCompany": "Naamloze vennootschap (nv)"
  },
  "durationInMonths": {
    "3": "3 maanden",
    "6": "6 maanden",
    "12": "1 jaar",
    "24": "2 jaar",
    "36": "3 jaar",
    "unknown": "{time}"
  },
  "PaymentType": {
    "PartnerFee": "Bemiddelingsfee"
  },
  "FunderType": {
    "Business": "Zakelijk",
    "Consumer": "Particulier"
  },
  "FundSourceType": {
    "Turnover": "Winst",
    "Loan": "Lening",
    "Donation": "Schenking",
    "Other": "Anders"
  },
  "FunderFileTypes": {
    "AnnualStatement": "Jaaroverzicht",
    "DeclarationOfSourceOfFunds": "Verklaring herkomst van middelen"
  },
  "FundingContractFileTypes": {
    "UnsignedContract": "Contract",
    "SignedContract": "Getekend contract",
    "SignedDeclarationOfSourceOfFunds": "Getekende verklaring herkomst van middelen",
    "ProofOfSigning": "Bewijs van ondertekening",
    "AnnualStatement": "Jaaroverzicht"
  },
  "FileTypes": {
    "SignedPartnerCooperationAgreement": "Samenwerkingsovereenkomst"
  },
  "FundingContractRenewalOptions": {
    "Renew": "Volledige verlenging",
    "RenewAndTopUp": "Verlenging met bijstorting",
    "PartiallyRenew": "Gedeeltelijke verlenging",
    "Expire": "Geen verlenging"
  },
  "FundingContractExpirationReason": {
    "InterestRateTooLow": "Rente te laag",
    "OtherInvestmentOptions": "Andere investeringsmogelijkheden",
    "MoneyNeededForOtherPurposes": "Geld nodig voor andere doeleinden",
    "Other": "Anders"
  },
  "FundingContractDeclinedReason": {
    "InterestRateTooLow": "Rente te laag",
    "OtherInvestmentOptions": "Andere investeringsmogelijkheden",
    "MoneyNeededForOtherPurposes": "Geld nodig voor andere doeleinden",
    "ContractTermsDoNotAlign": "Contractvoorwaarden komen niet overeen",
    "Other": "Anders"
  },
  "FundingContractActiveDissolveReason": {
    "PassedAway": "Overlijden",
    "Leniency": "Coulance",
    "Overfunding": "Overfunding",
    "KnowYourCustomer": "KYC / Wwft",
    "Other": "Anders"
  },
  "FundingContractSignedDissolveReason": {
    "DepositNotReceived": "Storting niet ontvangen",
    "KnowYourCustomer": "KYC / Wwft",
    "Other": "Anders"
  },
  "PartnerBusinessType": {
    "FinancialAdvisor": "Financieel adviseur",
    "Accountant": "Accountant",
    "AssetManager": "Vermogensbeheerder",
    "FamilyOffice": "Family office",
    "TaxAnalyst": "Fiscalist",
    "FinancialPlanner": "Financieel planner"
  },
  "PartnerType": {
    "SMEFinance": "Financieringspartner",
    "Funding": "Spaarpartner"
  },
  "FinanceReceiverStatus": {
    "PreScanSubmitted": "Pre-Scan ingediend",
    "PreScanInProgress": "Pre-Scan in behandeling",
    "PreScanRejected": "Pre-Scan afgewezen",
    "PreScanWithdrawn": "Pre-Scan ingetrokken",
    "Inactive": "Niet lenende klant",
    "Active": "Actief lenende klant",
    "Delinquent": "Klant in bijzonder beheer",
    "Defaulting": "Klant in gebreke",
    "Offboarded": "Klant-af"
  },
  "Genders": {
    "M": "M",
    "V": "V",
    "X": "X"
  },
  "AgreementStatus": {
    "Sent": "Beste {fullName},\n\n Om in te kunnen loggen op ons spaardersplatform is het belangrijk dat DebitRoom de samenwerkingsovereenkomst getekend retour heeft ontvangen. \n\nDeze is op {date} toegezonden. Wil je zorgdragen voor het tekenen hiervan? Dan kun je daarna verder met registreren. \n\nAlvast bedankt. \nTeam DebitRoom",
    "Open": "Beste {fullName},\n\n Om in te kunnen loggen op ons spaardersplatform is het belangrijk dat DebitRoom de samenwerkingsovereenkomst getekend retour heeft ontvangen. \n\nDeze zullen we je direct per e-mail toezenden. Wil je zorgdragen voor het tekenen hiervan? Dan kun je daarna verder met registreren. \n\nAlvast bedankt. \nTeam DebitRoom"
  },
  "LoanStatus": {
    "Requested": "Aangevraagd",
    "Approved": "Goedgekeurd",
    "ApprovedRenewal": "In afwachting van start",
    "ApprovedAndPaid": "Goedgekeurd en uitbetaald",
    "Rejected": "Afgewezen",
    "Completed": "Afgehandeld en terugbetaald",
    "CompletedAndRefunded": "Afgehandeld en terugbetaald",
    "Defaulting": "In gebreke",
    "Irrecoverable": "Oninbaar",
    "DirectDebitProcessing": "Betaling in behandeling",
    "DirectDebitsProcessing": "Betalingen in behandeling"
  },
  "CreditLimitDisabledReason": {
    "Defaulting": "De klant is in gebreke.",
    "ExpiredPsdAuthorization": "De klant heeft een verlopen PSD verbinding.",
    "NoConnectedSepa": "De klant mist een PSD verbinding voor de bankrekening van een van de SEPA contracten.",
    "CreditLimitRequest": "De klant heeft een kredietlimiet aanvraag ingediend.",
    "Disabled": "Het kredietlimiet is handmatig geblokkeerd.",
    "Onboarding": "De klant is nog bezig met het onboarding proces.",
    "Offboarded": "De klant is klant-af.",
    "Migrating": "De klant is geblokkeerd tot de migratie naar v2 is afgerond."
  }
}
